<template>
	<div class="width-100 logo-upload-wrapper" >
		<div class="img-responsive margin-bottom-10">
			<img :src="imageDataUrl" class="center-block" alt="Uploaded image">
		</div>
		<p v-if="field === 'profile_image'" class="upload-text" @click="toggleShow"> Upload your photo <span> here </span> </p>
		<p v-else-if="isDefaultImage" class="upload-text" @click="toggleShow"> Upload your logo <span> here </span> </p>
		<p v-else class="upload-text" @click="toggleShow"> Change your logo <span> here </span> </p>
		<p class="supported-text" @click="toggleShow"> Supports: .JPG, .JPEG, .PNG </p>
		<p class="supported-text" @click="toggleShow"> Recommended size:  < 2MB  </p>
		<vue-image-crop-upload ref="vueImageCropComponent" v-if="!endpoint"
															:field="field"
															@crop-success="cropSuccess"
															@crop-upload-success="cropUploadSuccess"
															@crop-upload-fail="cropUploadFail"
															v-model="show"
															:max-size="maxSize"
															:params="params"
															:headers="headers"
															img-format="png"
															langType="en">
		</vue-image-crop-upload>

		<vue-image-crop-upload ref="vueImageCropComponent" v-if="endpoint"
															:field="field"
															@crop-success="cropSuccess"
															@crop-upload-success="cropUploadSuccess"
															@crop-upload-fail="cropUploadFail"
															v-model="show"
															:max-size="maxSize"
															:url="endpoint"
															:params="params"
															:headers="headers"
															img-format="png"
															langType="en"
															:method="method">
		</vue-image-crop-upload>
	</div>
</template>

<script>
	import VueImageCropUpload from 'vue-image-crop-upload'
	import data2blob from 'vue-image-crop-upload/utils/data2blob.js'
	import PictureInput from 'vue-picture-input'

	const defaultImageSrc = '/dist/site/static/images/pictures.png'

	export default {
		name: 'ImageUpload',

		props: {
			imageSrc: {
				type: String,
			},
			uploaded: Boolean,
			endpoint: String,
			size: String,
			imageType: {
				type: String,
				default: 'logo'
			},
			method: {
				type: String,
				default: "POST"
			},
			field: {
				type: String,
				default: 'uploaded_image'
			}
		},

		beforeMount() {
			let token = document.head.querySelector('meta[name="csrf-token"]')
			if (token) {
				this.headers = {'X-CSRF-TOKEN': token.content}
			}
		},

		mounted() {
			this.params._token = $('meta[name="csrf-token"]').attr('content')
			this.loading = false
		},

		data: () => ({
			loading: true,

			show: false,

			params: {
				_token: null,
			},

			headers: {},

			maxSize: 2048,

		    newImageSrc: null,
		}),

		components: {
			'vue-image-crop-upload': VueImageCropUpload,
		    'picture-input': PictureInput
		},

		methods: {
			toggleShow() {
				this.show = !this.show
			},

			/**
			 * crop success
			 *
			 * [param] imgDataUrl
			 * [param] field
			 */
			cropSuccess(imgDataUrl, field) {
				this.newImageSrc = imgDataUrl;

 				let
					{
						imgFormat,
						mime,
						createImgUrl,
					} = this.$refs.vueImageCropComponent

				let form = new FormData()
				form.append(field, data2blob(createImgUrl, mime), field + '.' + imgFormat)
				this.$emit('imageUpdated', imgDataUrl, form.get(field))
			},

			/**
			 * upload success
			 *
			 * [param] jsonData  server api return data, already json encode
			 * [param] field
			 */
			cropUploadSuccess(jsonData, field) {
			},

			/**
			 * upload fail
			 *
			 * [param] status    server api return error status, like 500
			 * [param] field
			 */
			cropUploadFail(status, field) {

			}

		},

		computed: {
			imageDataUrl() {
				if (!_.isEmpty(this.newImageSrc)) {
					return this.newImageSrc
				}

				if (!_.isEmpty(this.imageSrc)) {
					return this.imageSrc
				}

				return defaultImageSrc
			},

		    isDefaultImage() {
				return this.imageDataUrl === defaultImageSrc
		    }
		},

		watch: {
			loading(to, from) {
				this.$emit('componentLoading', this.$options.name, to)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.logo-wrapper {
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;

			.logo-img {
					max-width: 58px;
			}
	}

	.logo-upload-wrapper {
	height: auto; 
	border: dashed; 
	border-color: #D7DEE3;     
	display: flex;
    flex-direction: column;
    padding: 2rem;
    align-items: center;
	}

	.upload-text {
		font-family: Circular Std;
		font-style: normal;
		font-weight: normal;
		font-size: 12px;
		line-height: 15px;
		text-align: center;
		letter-spacing: -0.01em;
		color: #949494;
	}
	
	.upload-text span {
		color: #1781EF;
	}

	.supported-text {
		font-family: Circular Std;
		font-style: normal;
		font-weight: normal;
		font-size: 10px;
		line-height: 12px;
		text-align: center;
		letter-spacing: 0.1px;
		color: #949494;
		}

	.center-block {
		max-width: 100px;
		max-height: 100px;
	}
</style>
